import { toast as originalToast } from 'react-hot-toast';

const originalToastError = originalToast.error;

// Override toast.error globally
originalToast.error = (message, options) => {
  // ✅ Allow bypassing global handler
  if (options?.skipGlobalHandler) {
    return originalToastError(message, options);
  }

  // Detect status from common API response shapes
  const status = message?.status || message?.response?.status;
  const detail = message?.data?.detail || message?.response?.data?.detail;

  if (status === 500) {
    return originalToastError('Server error 500. Please try again later.', options);
  }

  // If message is a string, show as-is
  if (typeof message === 'string') {
    if (message.length > 1000) {
      return originalToastError('Something went wrong, server error 500', options);
    }

    return originalToastError(message, options);
  }

  // Otherwise fallback to BE-provided message or generic
  return originalToastError(detail || 'Something went wrong.', options);
};

export const toast = originalToast;
